import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/system";
import { useUser } from "../Contexts/UserContext";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import CustomDatePicker from "./CustomDatePicker";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const monthList = [
  { MonthCode: "01", MonthName: "JANUARY" },
  { MonthCode: "02", MonthName: "FEBUARY" },
  { MonthCode: "03", MonthName: "MARCH" },
  { MonthCode: "04", MonthName: "APRIL" },
  { MonthCode: "05", MonthName: "MAY" },
  { MonthCode: "06", MonthName: "JUNE" },
  { MonthCode: "07", MonthName: "JULY" },
  { MonthCode: "08", MonthName: "AUGUST" },
  { MonthCode: "09", MonthName: "SEPTEMBER" },
  { MonthCode: "10", MonthName: "OCTOBER" },
  { MonthCode: "11", MonthName: "NOVEMBER" },
  { MonthCode: "12", MonthName: "DECEMBER" },
];
const reportTypeList = [
  {
    id: 1,
    label: "Pest control",
  },
  {
    id: 2,
    label: "Site Vist",
  },
  {
    id: 3,
    label: "Rest Room",
  },
  {
    id: 4,
    label: "Deep Cleaning",
  },
  {
    id: 5,
    label: "Wash Room",
  },
];

const CenteredInputLabel = styled(InputLabel)({
  transform: "translate(14px, 14px) scale(1)",
});
const ReportSelector4 = ({
  title,
  selectedData,
  setSelectedData,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  handleFetchReports,
  setIsReportFetched,
}) => {
  const [list, setList] = useState({ branchList: [], unitList: [] });
  const { user } = useUser();
  const { ClientId } = user;
  useEffect(() => {
    const fetchInitData = async () => {
      const res = await fetch(
        `${API_URL}/facility/get-client-all-unit/1/${ClientId}/0`
      ).then((res) => res.json());
      console.log(res);
      if (!res.success) {
        alert(res.message);
        return;
      }

      setList({
        branchList: [
          { BranchCode: "ALL", BranchName: "ALL" },
          ...res.data.branches,
        ],
        unitList: [{ UnitCode: "ALL", UnitName: "ALL" }, ...res.data.units],
      });
    };
    fetchInitData();
  }, []);
  const handleUnit = async (value) => {
    if (value.BranchCode == "ALL") {
      setList((prev) => ({
        ...prev,
        unitList: [{ UnitCode: "ALL", UnitName: "ALL" }],
      }));
      return;
    }
    const res = await fetch(
      `${API_URL}/facility/get-client-all-unit/2/${ClientId}/${value.BranchCode}`
    ).then((res) => res.json());
    if (!res.success) {
      alert(res.message);
      return;
    }
    setList((prev) => ({
      ...prev,
      unitList: res.data.units[0],
    }));
  };
  const OnDataSelect = (key, value) => {
    setIsReportFetched(false);
    if (value === null) return;
    if (key === "branchObj") {
      if (value == "ALL") {
        setSelectedData((prev) => ({
          ...prev,
          unitObj: { UnitCode: "ALL", UnitName: "ALL" },
        }));
        handleUnit(value);
      } else {
        setSelectedData((prev) => ({ ...prev, unitObj: null }));
        handleUnit(value);
      }
    }
    setSelectedData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack mt={1} mb={1} textAlign="start">
        <h2
          className="heading2"
          style={{
            fontSize: "14px",
            fontWeight: "500",
            padding: "0",
            lineHeight: "1px",
            margin: "0px 0px 0px 0vw",
            letterSpacing: "2px",
            textTransform: "uppercase",
            color: "#aaaaaa",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          {title}
          <style>
            {`
      .heading2::after {
        content: "";
    width: 120px;
    height: 1px;
    display: inline-block;
    background: #D10101;
    margin: 4px 10px;
      }
    `}
          </style>
        </h2>
      </Stack>
      <Box
        sx={{
          p: 2,
          mb: 2,
          bgcolor: "background.default",
          boxShadow: 3,
          borderRadius: 2,
          border: "2px solid #D10101",
        }}
      >
        {console.log("SD", selectedData)}
        <Stack
          width="100%"
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Autocomplete
            size="small"
            options={list.branchList || []}
            getOptionLabel={(option) => option.BranchName}
            getOptionSelected={(option, value) =>
              option.BranchName === value.BranchName
            }
            renderInput={(params) => (
              <TextField {...params} label="Branch" size="small" />
            )}
            value={selectedData.branchObj}
            onChange={(e, value) => {
              OnDataSelect("branchObj", value);
            }}
            sx={{
              minWidth: "20%",
            }}
          />
          <Autocomplete
            size="small"
            options={list.unitList || []}
            getOptionLabel={(option) => {
              console.log("option", option);
              return option.UnitName;
            }} // Ensure that UnitName is returned
            getOptionSelected={(option, value) =>
              option.UnitCode === value.UnitCode
            }
            renderInput={(params) => (
              <TextField {...params} label="Unit" size="small" />
            )}
            value={selectedData.unitObj}
            onChange={(e, value) => {
              OnDataSelect("unitObj", value);
            }}
            sx={{
              minWidth: "20%",
            }}
          />
          {/* <Autocomplete
            size="small"
            options={monthList || []}
            getOptionLabel={(option) => {
              return option.MonthName;
            }} // Ensure that UnitName is returned
            getOptionSelected={(option, value) =>
              option.MonthCode === value.MonthCode
            }
            renderInput={(params) => (
              <TextField {...params} label="Month" size="small" />
            )}
            value={selectedData.monthObj}
            onChange={(e, value) => {
              OnDataSelect("monthObj", value);
            }}
            sx={{
              minWidth: "20%",
            }}
          /> */}
          <CustomDatePicker
            label={"From Date"}
            date={fromDate}
            setDate={setFromDate}
          />
          <CustomDatePicker
            label={"To Date"}
            date={toDate}
            setDate={setToDate}
          />
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => handleFetchReports()}
            disabled={!selectedData.unitObj}
            sx={{
              fontSize: "12px",
            }}
          >
            Show
          </Button>
        </Stack>
      </Box>
    </LocalizationProvider>
  );
};

export default ReportSelector4;
